var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegacyMapView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-selector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8891 2.16016H4.6731C3.56853 2.16016 2.6731 3.05559 2.6731 4.16016V20.1602C2.6731 21.2647 3.56853 22.1602 4.6731 22.1602H7.8891V2.16016ZM4.6731 0.160156C2.46396 0.160156 0.673096 1.95102 0.673096 4.16016V20.1602C0.673096 22.3693 2.46396 24.1602 4.6731 24.1602H9.8891V0.160156H4.6731Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill-selector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3771 2.16016H10.1611V22.1602H15.3771V2.16016ZM8.16107 0.160156V24.1602H17.3771V0.160156H8.16107Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fill-selector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6731 2.16016H17.4571V22.1602H20.6731C21.7777 22.1602 22.6731 21.2647 22.6731 20.1602V4.16016C22.6731 3.05559 21.7777 2.16016 20.6731 2.16016ZM15.4571 0.160156V24.1602H20.6731C22.8822 24.1602 24.6731 22.3693 24.6731 20.1602V4.16016C24.6731 1.95102 22.8822 0.160156 20.6731 0.160156H15.4571Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacyMapView);
export default __webpack_public_path__ + "static/media/legacy-map-view.ae0d1b511ef53ae1002efadfe9cfc739.svg";
export { ForwardRef as ReactComponent };